"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLabelSuffix = void 0;
const PresentationContext_1 = require("../components/PresentationContext");
function getLabelSuffix(required) {
    var _a, _b;
    // We promise to always call `getLabelSuffix` deterministically
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { fieldProps } = (0, PresentationContext_1.usePresentationContext)();
    if (required === true) {
        return (_a = fieldProps === null || fieldProps === void 0 ? void 0 : fieldProps.labelSuffix) === null || _a === void 0 ? void 0 : _a.required;
    }
    else if (required === false) {
        return (_b = fieldProps === null || fieldProps === void 0 ? void 0 : fieldProps.labelSuffix) === null || _b === void 0 ? void 0 : _b.optional;
    }
    else {
        return undefined;
    }
}
exports.getLabelSuffix = getLabelSuffix;
